import { name as root } from '../actionTypes';

export const name = `${root}/customerSearch`

export const CUSTOMER_LOOKUP_REQUEST = `${name}/search`;
export const CUSTOMER_LOOKUP_SUCCESS = `${name}/success`;
export const CUSTOMER_LOOKUP_FAILURE = `${name}/failure`;

export const BLUR_FIELD = `${name}/blur`;
export const CHANGE_FIELD = `${name}/change`;
export const CLEAR_CRITERIA = `${name}/clear`;

